<template>
  <div class="post list-complete-item" v-if="post != null && post != undefined">
    <div class="post-header">
      <div class="profile-image">
        <img v-if="post.owner == null" style="cursor:unset !important;" />
        <img v-if="post.isAnnouncement" :src="$imageus + (currentEvent.logo == null ? host + '/static/500x500-user.png' : currentEvent.logo) + '?width=200&height=200&mode=cover'" alt="Event Logo" />
        <img v-if="post.owner != null && !post.isAnnouncement" :src="$imageus + (post.owner.image == null ? host + '/static/500x500-user.png' : post.owner.image.replaceAll($imageus, '')) + '?width=200&height=200&mode=cover'" @click="openUserModal(post)" />
      </div>
      <div class="user-details" @click="openUserModal(post)">
        <div class="username" v-if="!post.isAnnouncement">
          {{ post.owner == null ? currentEvent.title : post.owner.fullName }}
        </div>
        <div class="username" v-else>
          {{ currentEvent.title }}
        </div>
        <span class="time">{{ moment(post.createDate).fromNow() }}</span>
      </div>
      <div class="post-type">
        <i class="social-post-type announcement" v-if="post.type == 0 && post.isAnnouncement == true"></i>
        <i class="social-post-type survey" v-else-if="post.type == 1"></i>
        <i class="social-post-type poll" v-else-if="post.type == 2"></i>
        <i class="social-post-type chat" v-else-if="post.topic != null"></i>

        <!-- <i class="social-post-type chat" v-else></i> -->
        <!-- <el-button v-if=""></el-button> -->
        <el-dropdown v-if="post.owner != null && post.owner.id == currentUser.id">
          <span class="el-dropdown-link"><i class="fas fa-ellipsis-v"></i> </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="fas fa-trash" @click.native="deletePost(post.id)">{{ $t("socialhub.deletePost") }}</el-dropdown-item>
            <!-- <el-dropdown-item icon="el-icon-circle-plus">Action 2</el-dropdown-item>
            <el-dropdown-item icon="el-icon-circle-plus-outline">Action 3</el-dropdown-item>
            <el-dropdown-item icon="el-icon-check">Action 4</el-dropdown-item>
            <el-dropdown-item icon="el-icon-circle-check">Action 5</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="topic-area" v-if="post.topic != null" :style="'background-color:' + post.topic.color">
      <i>#</i><span class="topic-title">{{ post.topic.title }}</span>
    </div>
    <div class="post-text" v-if="post.postText != null">
      <div class="text" :class="{ 'line-clamp': post.postText.length > 200 }" v-html="parseUrl(post.postText, post)"></div>
      <span class="read-more" v-if="post.postText.length > 200">{{ $t("socialhub.readMore") }}</span>
    </div>
    <div class="poll-area" v-if="post.type == 1 && post.questions.length > 0">
      <div class="poll-title">
        {{ pollQuestion().title }}
      </div>
      <div class="poll-answer-list">
        <div class="poll-answer-wrapper" :class="(option.id == pollQuestion().answer ? 'selected' : '') + ' ' + (post.isJoined ? 'isApplied' : '')" v-for="(option, index) in pollQuestion().options" :key="option.id + '-pollOption-' + post.id + '--' + index" @click="post.isJoined != true && post.isOver == false ? (pollQuestion().answer = option.id) : null">
          <div class="answer-item">
            <span>{{ option.title }}</span>
            <span class="percentage" v-if="post.isJoined == true || post.isOver == true"> {{ "% " + option.percentage }} </span>
            <div class="polls-bar" :style="'transition: 1s; width: ' + option.percentage + '%;'" v-if="post.isJoined == true || post.isOver"></div>
            <span v-if="option.id == pollQuestion().answer && post.isJoined != true"><i class="fas fa-check"></i></span>
          </div>
        </div>
        <div class="poll-is-over" v-if="post.isOver && post.isJoined">
          {{ $t("socialhub.voteEnded") }}
        </div>
        <div class="poll-attendings">{{ $t("socialhub.voteJoinNumber", [attendingsPoll()]) }}</div>
      </div>

      <div class="poll-button" v-if="post.isJoined != true && post.type == 1">
        <el-button :loading="loading == 'pollLoading'" type="primary" :disabled="post.isOver || (post.questions[0].answer == null || post.questions[0].answer == '')" @click="attendPost"> {{ post.isOver ? $t("socialhub.voteEnd") : $t("socialhub.vote") }} </el-button>
      </div>
    </div>
    <div class="survey-area" v-if="post.type == 2">
      <div class="survey-title">
        {{ post.title }}
      </div>
      <div class="survey-joined-area" v-if="!surveyOpened">
        <el-button :type="post.isJoined ? 'success' : 'primary'" :disabled="post.isJoined" @click="openSurvey" :loading="loading == 'survey-opened'">{{ post.isJoined ? $t("socialhub.alreadyJoinSurvey") : $t("socialhub.join") }}</el-button>

        <div class="estimated-question">{{ $t("socialhub.surveyQuestionNumber", [post.estimatedQuestionCount]) }}</div>
      </div>
      <div class="survey-questions-area" v-if="surveyOpened">
        <!-- Single line text -->
        <transition name="el-fade-in" mode="out-in">
          <SurveyQuestionBuilder :registrationFormId="post.id" :question="availableQuestions[currentQuestionIndex]" :availableQuestions="availableQuestions" :currentIndex="currentQuestionIndex" :allQuestions="currentQuestionList" :key="availableQuestions[currentQuestionIndex].id" />
        </transition>
        <div class="footer">
          <div class="survey-index">{{ currentQuestionIndex + 1 }}/{{ availableQuestions.length }}</div>
          <div class="next-index">
            <el-button type="primary" :loading="loading == 'surveyLoading' || loading == 'nextQuestion'" @click="nextQuestion">{{ $t("socialhub.next") }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="post-image" v-if="post.image != null">
      <img :src="post.image" />
    </div>
    <div class="post-attending" v-if="post.attendings > 0 && post.type != 1">{{ post.attendings }} {{ $t("socialhub.talkingPeople") }}</div>
    <div class="post-buttons-bar">
      <i class="far fa-comment" @click="openComment"></i>
      <div class="comment-count" v-if="post.comments > 0" @click="openComment">{{ post.comments }} {{ $t("socialhub.bigComment") }}</div>
      <div
        class="comment"
        @click="
          newComment = !newComment;
          comment.commentText = null;
        "
        v-else
      >
        {{ $t("socialhub.doComment") }}
      </div>
      <div
        class="comment-reply"
        v-if="post.comments > 0"
        @click="
          newComment = !newComment;
          comment.commentText = null;
        "
        :style="{ color: newComment ? '#FF6565' : '#292F3B' }"
      >
        {{ newComment ? $t("socialhub.cancel") : $t("socialhub.reply") }}
      </div>
      <div class="liked-area" @click="toggleLike(post)">
        <span>{{ post.isLiked ? $t("socialhub.alreadyLike") : $t("socialhub.like") }}</span>
        <i :class="!post.isLiked ? 'far fa-thumbs-up' : 'fas fa-thumbs-up'"></i>
      </div>
    </div>
    <transition name="el-zoom-in-top" mode="out-in">
      <div class="send-comment" v-if="newComment" :key="'new-comment-area-' + post.id + '-key-' + newComment" @keyup.enter.exact="postComment()">
        <div v-if="isCommentMentionVisible" v-dragscroll.x class="mention-panel">
          <div v-for="(user, index) in users" :key="index" @click="tagUser(user, post)" class="mention-item">
            <div :style="user.image == null ? 'background-color: f1f1f1;' : 'background-image: url(' + $imageus + user.image + '?width=200&height=200&mode=cover&background=ffffff'" class="user-image"></div>
            <p v-if="user.type == 2">{{ user.title }}</p>
            <p else>{{ user.fullName }}</p>
          </div>
        </div>
        <el-input v-model="comment.commentText" resize="auto" class="comment-input" @input="commentMention(post)">
          <template slot="suffix">
            <i class="el-input__icon fas " :class="loading == 'postCommentLoading' ? 'el-icon-loading' : 'fa-paper-plane'" @click="postComment()"></i>
          </template>
        </el-input>
      </div>
    </transition>

    <div class="post-comment-area" v-if="commentOpen">
      <transition-group name="list-complete" tag="div">
        <Comment v-for="comment in post.postComments" :key="comment.id + '-post-parent-comment'" :comment="comment" />
      </transition-group>
      <div class="load-comment-btn" v-if="loadCommentBtn">
        <el-button type="primary" round size="mini" :loading="loading == 'loadComments'" @click="loadComment">{{ $t("socialhub.loadMore") }}</el-button>
      </div>
      <div class="load-comment-btn" v-else>
        <el-button size="mini" type="success" round @click="commentOpen = false">{{ $t("socialhub.hideComments") }}</el-button>
      </div>
    </div>

    <div class="post-liked-users-area" v-if="post.likes > 0">
      <span v-if="post.isLiked && post.likes == 1"> {{ $t("socialhub.likeYou") }} </span>
      <span v-else-if="post.isLiked && post.likes - 1 > 0"> {{ $t("socialhub.likeYouAndMore", [post.likes - 1]) }} </span>
      <span v-else> {{ $t("socialhub.likeMore", [post.likes]) }}</span>
      <div class="liked-users" v-if="post.latestLikes.length > 0">
        <img v-for="user in post.latestLikes" :key="user.id + '-latest-likes-user'" :src="user.image != null ? user.image : host + '/static/500x500-user.png'" :alt="user.fullName" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { dragscroll } from "vue-dragscroll";
import moment from "moment/min/moment-with-locales";
import Comment from "./Comment.vue";
import $ from "jquery";
import SurveyQuestionBuilder from "./SurveyQuestionBuilder.vue";
export default {
  directives: {
    dragscroll
  },
  components: {
    Comment,
    SurveyQuestionBuilder
  },
  props: ["post"],
  data() {
    return {
      axios,
      moment,
      host: location.host == "localhost:3000" ? "https://live.holacon.com/" : "https://" + location.host,
      newComment: false,
      isCommentMentionVisible: false,
      users: [],
      searchTerm: null,
      comment: {
        id: null,
        postId: this.post.id,
        commentText: null,
        parentId: null,
        mentions: []
      },
      loading: false,
      timeout: null,
      commentOpen: false,
      loadCommentBtn: true,
      availableQuestions: [],
      currentQuestionList: [],
      surveyOpened: false,
      currentQuestionIndex: 0,
      firstOpen: false
    };
  },
  methods: {
    openUserModal(post) {
      if (post.owner.id != null) {
        this.$root.$emit("getProfile", post.owner.id);
      }
    },
    async deletePost(id) {
      await this.$store.dispatch("deletePost", id);
    },
    validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    },
    async nextQuestion() {
      this.loading = "nextQuestion";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        var currentQuestion = this.availableQuestions[this.currentQuestionIndex];
        if (currentQuestion.isRequired == true && (currentQuestion.answer == null || currentQuestion.answer == "") && currentQuestion.type != 100 && currentQuestion.type != 32 && currentQuestion.type != 104) {
          this.$message.error(this.$t("socialValid.nullCheck"));
        } else if (currentQuestion.isRequired == true && (currentQuestion.answer == null || currentQuestion.answer == "") && currentQuestion.type == 16 && currentQuestion.type == 8 && !currentQuestion.allowMultipleSelections) {
          this.$message.error(this.$t("socialValid.nullCheck"));
        } else if (currentQuestion.isRequired == true && currentQuestion.answers.length == 0 && (currentQuestion.type == 100 || currentQuestion.type == 104 || currentQuestion.type == 32 || (currentQuestion.type == 16 && currentQuestion.allowMultipleSelections))) {
          this.$message.error(this.$t("socialValid.nullCheck2"));
        } else if (currentQuestion.type != 16 && currentQuestion.type != 100 && currentQuestion.type != 32 && currentQuestion.type != 104 && currentQuestion.isRequired && currentQuestion.answer != null && currentQuestion.answer.length < currentQuestion.minLength) {
          this.$message.error(this.$t("socialValid.minLength", [currentQuestion.minLength]));
        } else if ((currentQuestion.type == 12 || currentQuestion.type == 1) && !this.validateEmail(currentQuestion.answer)) {
          this.$message.error(this.$t("socialValid.email"));
        } else {
          if (this.availableQuestions.length == this.currentQuestionIndex + 1) {
            var dammyQuestion = JSON.parse(JSON.stringify(this.availableQuestions));
            dammyQuestion = dammyQuestion.map(x => {
              if (x.answer != null) {
                x = {
                  ...x,
                  answer: x.answer.toString()
                };
              }
              return x;
            });
            var payload = {
              postId: this.post.id,
              postType: this.post.type,
              questions: dammyQuestion
            };

            this.loading = "surveyLoading";
            if (this.timeout != null) clearTimeout(this.timeout);
            this.timeout = setTimeout(async () => {
              var res = await this.$store.dispatch("attendPostPoll", payload);
              if (res.status == 200 && !res.data.hasError) {
                this.post.isJoined = true;
                this.surveyOpened = false;
              } else {
                this.surveyOpened = false;
                this.availableQuestions = [];
                this.currentQuestionList = [];
              }
              this.loading = false;
            }, 500);
            return;
          }
          this.currentQuestionIndex += 1;
        }
        this.loading = false;
      }, 200);
    },
    async openSurvey() {
      if (!this.post.isJoined) {
        this.loading = "survey-opened";
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          var res = await this.$store.dispatch("getQuestionObjects", { id: this.post.id, type: 2 });
          if (!res.data.hasError) {
            this.currentQuestionList = res.data.data.items;
            this.availableQuestions = res.data.data.items.filter(x => x.parentAnswerId == null && x.parentQuestionId == null);
            this.surveyOpened = true;
          } else {
            this.surveyOpened = false;
          }
          this.loading = false;
        }, 500);
      }
    },
    async attendPost() {
      this.loading = "pollLoading";
      if(this.post.questions[0].answer == null || this.post.questions[0].answer == ''){
        this.loading = false
        return
      }
      var payload = {
        postId: this.post.id,
        postType: this.post.type,
        questions: this.post.questions
      };
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("attendPostPoll", payload);
        if (res.status == 200 && !res.data.hasError) {
          this.post.isJoined = true;
          this.surveyOpened = false;
        } else {
          this.surveyOpened = false;
          this.availableQuestions = [];
          this.currentQuestionList = [];
        }
        this.loading = false;
      }, 500);
    },
    attendingsPoll() {
      var count = 0;
      this.post.questions[0].options.forEach(x => {
        count += x.count;
      });
      return count;
    },
    pollQuestion() {
      return this.post.questions[0];
    },
    async loadComment() {
      this.loading = "loadComments";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("/SocialHub/ListComments", {
          skip: this.post.postComments.length,
          take: 5,
          parentId: null,
          postId: this.post.id
        });
        var comments = res.data.data.items;
        comments = comments.map(x => {
          return {
            ...x,
            subComments: []
          };
        });
        if (comments.length > 0) {
          this.post.postComments.push(...comments.reverse());
        } else {
          this.loadCommentBtn = false;
        }
        this.loading = false;
      }, 500);
    },
    async openComment() {
      if (!this.firstOpen) {
        var res = await axios.post("/SocialHub/ListComments", {
          skip: this.post.postComments.length,
          take: 5,
          parentId: null,
          postId: this.post.id
        });
        var comments = res.data.data.items;
        comments = comments.map(x => {
          return {
            ...x,
            subComments: []
          };
        });
        if (comments.length > 0) {
          this.post.postComments.push(...comments.reverse());
        }
        if (res.data.data.items.length == 5) {
          this.skip += 5;
          this.loadCommentBtn = true;
        } else {
          this.loadCommentBtn = false;
        }
        this.firstOpen = true;
      }
      this.commentOpen = !this.commentOpen;
    },
    async postComment() {
      this.loading = "postCommentLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var commentTitle = this.comment.commentText;
        this.comment.mentions.forEach(user => {
          commentTitle = commentTitle.replace(user.fullName, "%" + user.id + "%");
        });
        var res = await axios.post("socialhub/addupdatecomment", {
          id: null,
          parentId: null,
          postId: this.post.id,
          commentText: commentTitle != "" ? commentTitle : this.comment.commentText,
          mentions: this.comment.mentions
        });
        if (res.data.hasError == true) {
          this.$message.error(res.data.message);
        } else {
          this.comment.commentText = null;
          this.users = [];
        }
        this.newComment = false;
        this.loading = false;
      }, 500);
    },
    tagUser(user, post) {
      this.isCommentMentionVisible = false;
      this.comment.commentText = this.comment.commentText.replace("@" + this.searchTerm, user.fullName);
      this.comment.mentions.push(user);
      this.users = [];
      this.searchTerm = "";
      this.users = [];
    },
    commentMention(post) {
      if (this.comment.commentText != "" && this.comment.commentText != null) {
        this.comment.commentText.split(" ").forEach(item => {
          if (item.startsWith("@")) {
            this.users = [];
            this.isCommentMentionVisible = true;
            this.searchTerm = item.replace("@", "");
            setTimeout(() => {
              axios
                .post("socialhub/searchmention", {
                  searchTerm: this.searchTerm
                })
                .then(res => {
                  this.users = res.data.data.items;
                });
            }, 1000);
          } else {
            this.isCommentMentionVisible = false;
            this.searchTerm = "";
          }
        });
      }
    },
    async toggleLike(item) {
      var payload = {
        id: item.id,
        isLiked: !item.isLiked
      };
      var res = await axios.post("socialhub/togglelike", payload);
      if (res.data.hasError) {
        this.$message.error(res.data.message);
      } else {
        this.post.isLiked = !item.isLiked;
      }
    },
    parseUrl(text, post) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      var usernameRegex = /\%(.*?)\%/g;
      if (text == null) return;
      text = text.replace(urlRegex, function(url) {
        return '<a href="' + url + '" target="_blank">' + url + "</a>";
      });
      post.mentions.forEach(user => {
        if (text.includes("%" + user.id + "%")) {
          text = text.replace("%" + user.id + "%", '<a href="javascript:;" user-id="' + user.id + '" class="open-user">@' + user.fullName + "</a>");
        }
      });
      return text;
    },
    test() {
      this.$message.info("test");
    }
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentUser() {
      return this.$store.getters.getUser;
    },
    finishSurvery() {
      return this.availableQuestions.filter(x => (x.type == 100 ? x.answers.length == 0 : x.answer == null)).length > 1 ? false : true;
    }
  }
};
</script>

<style lang="less">
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/event/socialHub/PostCard.vue